import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditMeetingRoomModal from '../components/pages/meeting-room/edit-properties/content';
import { getCallQualityProfiles } from '../actions/portalSetting';

export default function EditMeetingRoomPropertiesModal(props) {
  const selectedMeetingRoom = useSelector((state) => state.meetingRoomReducer.selectedMeetingRoom);
  const meetingRoomForm = useSelector((state) => state.meetingRoomReducer.meetingRoomForm);
  const callQualityOptions = useSelector(
    (state) => state.portalSettingReducer.videoQualityProfile.callQualityOptions || []
  );
  const dispatch = useDispatch();

  return (
    <>
      <EditMeetingRoomModal
        selectedMeetingRoom={selectedMeetingRoom}
        meetingRoomForm={meetingRoomForm}
        callQualityOptions={callQualityOptions}
        updateOrView={props.updateOrView}
        dispatch={dispatch}
      />
    </>
  );
}
